import request from 'superagent'
import {checkToken} from 'conf'

export default (userName, token, cb) =>  {
  request
    .get(checkToken(userName, token))
    .set('X-authorization', token)    
    .end(err => cb(err))
}



/** WEBPACK FOOTER **
 ** ./app/api/checkToken.js
 **/